/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body, _showTierToast, _listenersAttached, _peelaBottleCount;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  // Peela discount tier data
  var _peelaCartTiers = [
    { min: 1,  drawerMsg: "You're 1 bottle from 10% off. Mix any sizes \u2014 the discount grows with every bottle you add (up to 35% for the full set).", drawerCta: "Shop all shades",         ctaUrl: "/products/peela-nails", toastMsg: "Nice pick. Add 1 more to unlock 10% off your whole order.",                         toastCta: "Add another shade",   btnText: "Add 1 More for 10% OFF" },
    { min: 2,  drawerMsg: "10% off applied. Add 1 more polish and you'll bump to 15% off your whole cart.",                                                   drawerCta: "Add 1 more",              ctaUrl: "/products/peela-nails", toastMsg: "10% off unlocked \uD83C\uDF89 1 more = 15% off.",                                          toastCta: "Add 1 more",          btnText: "Add 1 More for 15% OFF" },
    { min: 3,  drawerMsg: "15% off applied. 1 more bottle unlocks 20% off \u2014 that's a fifth off everything.",                                            drawerCta: "Add 1 more",              ctaUrl: "/products/peela-nails", toastMsg: "15% off unlocked. 1 more = 20% off.",                                                  toastCta: "Add 1 more",          btnText: "Add 1 More for 20% OFF" },
    { min: 4,  drawerMsg: "20% off applied \u2014 a fifth off. Every polish from here bumps your discount, up to 35% for all 10 shades.",                   drawerCta: "Add 1 more",              ctaUrl: "/products/peela-nails", toastMsg: "20% off unlocked \uD83C\uDF89 1 more = 23% off.",                                          toastCta: "Add 1 more",          btnText: "Add 1 More for 23% OFF" },
    { min: 5,  drawerMsg: "23% off applied. Halfway to the full range \u2014 1 more polish bumps you to 26% off.",                                           drawerCta: "Add 1 more",              ctaUrl: "/products/peela-nails", toastMsg: "23% off unlocked. 1 more = 26% off.",                                                  toastCta: "Add 1 more",          btnText: "Add 1 More for 26% OFF" },
    { min: 6,  drawerMsg: "26% off applied \u2014 over a quarter off your order. 1 more bottle = 29%.",                                                     drawerCta: "Add 1 more",              ctaUrl: "/products/peela-nails", toastMsg: "26% off unlocked. 1 more = 29% off.",                                                  toastCta: "Add 1 more",          btnText: "Add 1 More for 29% OFF" },
    { min: 7,  drawerMsg: "29% off applied. Closing in on a third off \u2014 1 more bottle unlocks 31%.",                                                    drawerCta: "Add 1 more",              ctaUrl: "/products/peela-nails", toastMsg: "29% off unlocked. 1 more = 31% off.",                                                  toastCta: "Add 1 more",          btnText: "Add 1 More for 31% OFF" },
    { min: 8,  drawerMsg: "31% off applied. 2 more bottles unlock the Complete Collection discount \u2014 35% off, the maximum saving.",                    drawerCta: "Complete the Collection", ctaUrl: "/products/peela-nails", toastMsg: "31% off unlocked. 2 to go for the max 35%.",                                            toastCta: "Keep going",          btnText: "Add 2 More for 35% OFF" },
    { min: 9,  drawerMsg: "33% off applied. You're 1 bottle from the Complete Collection unlock \u2014 35% off, the biggest saving we offer. At this tier the next bottle effectively only costs a few pounds.", drawerCta: "Complete the Collection", ctaUrl: "/products/peela-nails", toastMsg: "33% off unlocked. 1 more = 35% (max discount).",                                       toastCta: "Complete the set",    btnText: "Add 1 More for 35% OFF" },
    { min: 10, drawerMsg: "35% off applied \u2014 the Complete Collection tier. That's the biggest discount we offer. Enjoy!",                              drawerCta: "Checkout",                ctaUrl: "/checkout",             toastMsg: "35% off unlocked \u2014 max discount \uD83C\uDF89",                                      toastCta: "Checkout",            btnText: "Max Discount Applied \uD83C\uDF89" }
  ];

  function _getPeelaTier(count) {
    var tier = _peelaCartTiers[0];
    for (var i = _peelaCartTiers.length - 1; i >= 0; i--) {
      if (count >= _peelaCartTiers[i].min) { tier = _peelaCartTiers[i]; break; }
    }
    return tier;
  }

  function _buildTierHtml(tier, count) {
    if (count === 0) return '';
    return '<div class="peela-tier-bar"></div>';
  }

  function _buildProgressDots(count) {
    var html = '';
    for (var i = 1; i <= 10; i++) {
      html += '<span class="peela-tier-dot' + (i <= count ? ' filled' : '') + '"></span>';
    }
    return html;
  }

  function _isPeelaProductButton($btn) {
    var btnHandle = (($btn.attr('data-product-handle') || '') + '').toLowerCase();
    if (btnHandle === 'peela-nails') return true;

    var $form = $btn.closest('form');
    var formHandle = (($form.attr('data-product-handle') || '') + '').toLowerCase();
    if (formHandle === 'peela-nails') return true;

    // Product detail page fallback: only treat main PDP add-to-cart buttons as Peela
    // when browsing the Peela product URL.
    var onPeelaProductPage = window.location.pathname.indexOf('/products/peela-nails') !== -1;
    if (onPeelaProductPage && ($btn.hasClass('engoj-btn-addtocart') || $btn.hasClass('btn-add-stickycart') || $btn.closest('#AddToCartForm').length)) {
      return true;
    }

    var $card = $btn.closest('.engoj_grid_parent, .product, .product-item-v1, .product-item-v2, .product-item-v3, .product-item-v4, .product-item-v5, .product-item-v6, .product-item-v7, .product-item-v8, .product-item-v9, .product-item-v10, .grid-item, li');
    if ($card.length && $card.find('a[href*="/products/peela-nails"]').length > 0) return true;

    return false;
  }

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '.enj-add-to-cart-btn',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Attach event listeners only once — prevents duplicate handlers when init() is
    // called multiple times (e.g. after AJAX filter reload or load-more in collection.js)
    if (!_listenersAttached) {
      _listenersAttached = true;

      // Setup ajax quantity selectors on the any template if enableQtySelectors is true
      if (settings.enableQtySelectors) {
        qtySelectors();
      }

      // Take over the add to cart form submit action if ajax enabled
      if (!settings.disableAjaxCart) {
        formOverride();
      }

      // Run this function in case we're using the quantity selector outside of the cart
      adjustCart();
    }

    // Pre-build cart on page load so properties are visible when drawer is opened
    loadCart();
  };

  loadCart = function () {
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $('.product-popup').find('.product-item-count').html(cart.item_count);  
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $('.js-number-cart').removeClass('active');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    // Use event delegation on $body so ALL add-to-cart forms are covered regardless
    // of when they were inserted into the DOM (homepage sections, AJAX-loaded content, etc.)
    $body.on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass('is-added').addClass('is-adding');
      $addToCart_btn.find("i").replaceWith('<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      // Wrap the error callback with a closure so itemErrorCallback receives
      // the correct form element, not the stale module-level $formContainer.
      var $currentForm = $(this);
      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, function(xhr, status) {
        itemErrorCallback(xhr, status, $currentForm);
      });
    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass('is-adding').addClass('is-added');
    $addToCart_btn.find('.enj-loader-add-to-cart').html('<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve" id="svg2" version="1.1"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs6"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,400)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="/* fill:#231f20; */fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/></g></g></svg>');

    $('.product-popup').find('.product-name').html(product.title);  
    $('.product-popup').find('.product-price').html(Shopify.formatMoney(product.price, settings.moneyFormat)); 
    $('.product-popup').find('.product-qty').html(product.quantity,); 
                                                  $('.product-popup').find('.product-total').html(Shopify.formatMoney(product.line_price, settings.moneyFormat)); 


    $('.product-popup').find('.product-image img').attr('src', product.image);

    $('.js-minicart').addClass('active');
    $('.bg-minicart').addClass('active');

    if (product.handle === 'peela-nails') {
      _showTierToast = true;
      // Instant optimistic button update before async getCart returns
      var addedQty = parseInt($(form).find('[name="quantity"]').val()) || 1;
      _peelaBottleCount = (_peelaBottleCount || 0) + addedQty;
      var optTier = _getPeelaTier(_peelaBottleCount);
      // Instant optimistic button update — only on text-label buttons, not icon-only SVG buttons
      $('.enj-add-to-cart-btn, .btn-add-stickycart').each(function() {
        var $btn = $(this);
        if ($btn.data('peela-orig') === undefined) { $btn.data('peela-orig', $btn.html()); }
        var hasDirectText = $btn.contents().filter(function() {
          return this.nodeType === 3 && this.textContent.trim().length > 0;
        }).length > 0;
        if (!hasDirectText) return;
        if (!_isPeelaProductButton($btn)) return;
        $btn.text(optTier.btnText);
      });
    }
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus, $form) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    // Use the specific form/button that submitted, falling back to the module-level snapshot.
    var $btn = $form ? $form.find(settings.addToCartSelector) : $addToCart;
    $btn.removeClass('is-adding is-added');
    $btn.find('.enj-loader-add-to-cart').remove();

    if (!!data.message) {
      if (data.status == 422) {
        ($form || $formContainer).after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Count peela-nails bottles before any early return — banner and button must always update
    var totalBottles = 0;
    $.each(cart.items, function(i, item) { if (item.handle === 'peela-nails') { totalBottles += item.quantity; } });
    _peelaBottleCount = totalBottles;
    var peelaTier = _getPeelaTier(totalBottles);

    // Always update cart drawer tier banner (even when cart is empty)
    var onPeelaPage = window.location.pathname.indexOf('/products/peela-nails') !== -1;
    var banner = document.getElementById('peela-tier-banner');
    if (banner) {
      if (totalBottles > 0) {
        var dotsEl = document.getElementById('peela-tier-banner-dots');
        if (dotsEl) dotsEl.innerHTML = _buildProgressDots(totalBottles);
        document.getElementById('peela-tier-banner-msg').textContent = peelaTier.drawerMsg;
        var bannerCta = document.getElementById('peela-tier-banner-cta');
        bannerCta.textContent = peelaTier.drawerCta;
        bannerCta.href = peelaTier.ctaUrl;
        banner.classList.add('active');
      } else if (onPeelaPage) {
        var dotsEl0 = document.getElementById('peela-tier-banner-dots');
        if (dotsEl0) dotsEl0.innerHTML = '';
        document.getElementById('peela-tier-banner-msg').textContent = 'Mix any sizes — discount grows with every bottle you add.';
        var bannerCta0 = document.getElementById('peela-tier-banner-cta');
        if (bannerCta0) { bannerCta0.textContent = 'Shop all shades'; bannerCta0.href = '/products/peela-nails'; }
        banner.classList.add('active');
      } else {
        banner.classList.remove('active');
      }
    }

    // Always update add-to-cart button text (only on text-label buttons, not icon-only SVG buttons)
    $('.enj-add-to-cart-btn, .btn-add-stickycart').each(function() {
      var $btn = $(this);
      if ($btn.data('peela-orig') === undefined) { $btn.data('peela-orig', $btn.html()); }
      // Skip icon-only buttons — only update buttons that have a direct text node
      var hasDirectText = $btn.contents().filter(function() {
        return this.nodeType === 3 && this.textContent.trim().length > 0;
      }).length > 0;
      if (!hasDirectText) return;
      if (!_isPeelaProductButton($btn)) {
        $btn.html($btn.data('peela-orig'));
        return;
      }
      if (totalBottles > 0) {
        $btn.text(peelaTier.btnText);
      } else {
        $btn.html($btn.data('peela-orig'));
      }
    });

    // Show empty cart and return early
    if (cart.item_count === 0) {
      $cartContainer
      .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Pre-render properties as HTML string
      var propsHtml = '';
      if (cartItem.properties) {
        Object.keys(cartItem.properties).forEach(function(k) {
          var val = cartItem.properties[k];
          if (val) {
            propsHtml += '<div class="ajaxcart__property">' + val + '</div>';
          }
        });
      }

      var originalPrice = cartItem.original_price != null ? cartItem.original_price : cartItem.price;
      var finalPrice = cartItem.final_price != null ? cartItem.final_price : cartItem.price;
      var itemDiscountsHtml = '';
      if (cartItem.line_level_discount_allocations && cartItem.line_level_discount_allocations.length) {
        $.each(cartItem.line_level_discount_allocations, function(_, allocation) {
          var discountTitle = allocation.discount_application && allocation.discount_application.title ? allocation.discount_application.title : 'Discount';
          var discountAmount = Number(allocation.amount) || 0;
          itemDiscountsHtml += '<div class="ajaxcart__discount">' + discountTitle + ': -' + Shopify.formatMoney(discountAmount, settings.moneyFormat) + '</div>';
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: propsHtml,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        priceHtml: originalPrice > finalPrice
          ? '<span class="ajaxcart__price--compare">' + Shopify.formatMoney(originalPrice, settings.moneyFormat) + '</span><span class="price_sale">' + Shopify.formatMoney(finalPrice, settings.moneyFormat) + '</span>'
          : '<span class="price_sale">' + Shopify.formatMoney(finalPrice, settings.moneyFormat) + '</span>',
        discountsHtml: itemDiscountsHtml,
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    var tierMsgHtml = _buildTierHtml(peelaTier, totalBottles);

    var subtotalPrice = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
    var totalDiscount = cart.total_discount != null ? cart.total_discount : Math.max(0, subtotalPrice - cart.total_price);
    var discountTitles = [];
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      $.each(cart.cart_level_discount_applications, function(_, application) {
        if (application.title) { discountTitles.push(application.title); }
      });
    }

    data = {
      items: items,
      note: cart.note,
      hasDiscount: totalDiscount > 0,
      subtotalPrice: Shopify.formatMoney(subtotalPrice, settings.moneyFormat),
      discountLabel: discountTitles.length ? discountTitles.join(', ') : 'Discount',
      totalDiscount: Shopify.formatMoney(totalDiscount, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      tierMsg: tierMsgHtml
    }
    $('.product-popup').find('.product-total-cart').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    $cartContainer.append(template(data));

    var summaryCompareTotal = 0;
    var summaryFinalTotal = cart.total_price != null ? cart.total_price : 0;
    var pendingSummaryItems = cart.items.length;

    function updateSummaryValues() {
      var $summaryValues = $cartContainer.find('.ajaxcart__summary-values');
      if (!$summaryValues.length) return;

      var compareTotal = Math.max(summaryCompareTotal, cart.original_total_price || 0, summaryFinalTotal || 0);
      var finalTotal = summaryFinalTotal;

      if (compareTotal > finalTotal) {
        $summaryValues.html('<span class="ajaxcart__price--compare">' + Shopify.formatMoney(compareTotal, settings.moneyFormat) + '</span><span class="ajaxcart__summary-final">' + Shopify.formatMoney(finalTotal, settings.moneyFormat) + '</span>');
      } else {
        $summaryValues.html('<span class="ajaxcart__summary-final">' + Shopify.formatMoney(finalTotal, settings.moneyFormat) + '</span>');
      }
    }

    function finalizeSummaryItem(comparePrice, finalPrice, qty) {
      var safeQty = qty || 0;
      var unitFinal = finalPrice != null ? finalPrice : 0;
      var unitCompare = comparePrice != null ? comparePrice : unitFinal;

      summaryCompareTotal += unitCompare * safeQty;
      pendingSummaryItems -= 1;
      if (pendingSummaryItems <= 0) {
        updateSummaryValues();
      }
    }

    window._peelaProductDataCache = window._peelaProductDataCache || {};
    $.each(cart.items, function(index, cartItem) {
      var handle = cartItem.handle;
      var fallbackCompare = cartItem.original_price != null ? cartItem.original_price : cartItem.price;
      var fallbackFinal = cartItem.final_price != null ? cartItem.final_price : cartItem.price;
      if (!handle) {
        finalizeSummaryItem(fallbackCompare, fallbackFinal, cartItem.quantity);
        return;
      }

      var rowSelector = '.ajaxcart__row[data-line="' + (index + 1) + '"] .product_price';
      var $priceCell = $cartContainer.find(rowSelector);
      if (!$priceCell.length) return;

      var applySalePricing = function(productData) {
        var comparePrice = fallbackCompare;
        var finalPrice = fallbackFinal;

        if (productData && productData.variants && productData.variants.length) {
          for (var i = 0; i < productData.variants.length; i++) {
            var variant = productData.variants[i];
            if (String(variant.id) === String(cartItem.variant_id)) {
              if (variant.compare_at_price && variant.compare_at_price > comparePrice) {
                comparePrice = variant.compare_at_price;
              }
              break;
            }
          }
        }

        if (comparePrice > finalPrice) {
          $priceCell.html('<span class="ajaxcart__price--compare">' + Shopify.formatMoney(comparePrice, settings.moneyFormat) + '</span><span class="price_sale">' + Shopify.formatMoney(finalPrice, settings.moneyFormat) + '</span>');
        }

        finalizeSummaryItem(comparePrice, finalPrice, cartItem.quantity);
      };

      if (window._peelaProductDataCache[handle]) {
        applySalePricing(window._peelaProductDataCache[handle]);
      } else {
        $.getJSON('/products/' + handle + '.js').done(function(productData) {
          window._peelaProductDataCache[handle] = productData;
          applySalePricing(productData);
        }).fail(function() {
          finalizeSummaryItem(fallbackCompare, fallbackFinal, cartItem.quantity);
        });
      }
    });

    if (pendingSummaryItems === 0) {
      updateSummaryValues();
    }

    // Update product page tier box if present in DOM (currently hidden, reserved for future)
    var prodTier = document.getElementById('peela-product-tier');
    var landingTeaser = document.getElementById('peela-landing-teaser');
    if (prodTier) {
      if (totalBottles > 0) {
        var prodDots = document.getElementById('peela-product-tier-dots');
        if (prodDots) prodDots.innerHTML = _buildProgressDots(totalBottles);
        document.getElementById('peela-product-tier-msg').textContent = peelaTier.toastMsg;
        var prodCta = document.getElementById('peela-product-tier-cta');
        prodCta.textContent = peelaTier.toastCta;
        prodCta.href = peelaTier.ctaUrl;
        prodTier.style.display = 'block';
        if (landingTeaser) landingTeaser.style.display = 'none';
      } else {
        prodTier.style.display = 'none';
        if (landingTeaser) landingTeaser.style.display = '';
      }
    }

    cartCallback(cart);
    $('.js-number-cart').addClass('active');
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on('change', '.ajaxcart__qty-num', function() {
      var $input = $(this),
          line = $input.data('line'),
          qty = parseInt($input.val().replace(/\D/g, ''), 10);

      qty = validateQty(qty);
      if (qty < 0) qty = 0;
      $input.val(qty);

      if (line) {
        updateQuantity(line, qty);
      }
    });

    $body.on('click', '.remove-product', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = 0
      if (line) {
        updateQuantity(line, qty);
      } else {
        return;
      }
    })

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input.
      // Delegated on $body so it works even if the input is replaced after init.
      $body.on('click', '.js-qty__adjust', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          console.log(qty);
          updatePricingQty(qty);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
